const routes = {
  home: '/home',
  signin: '/signin',
  signup: '/signup',
  pricing: '/pricing',
  onboarding: '/onboarding',
  offices: '/offices',
  book: '/book',
  bookFor: '/book/:forDate',
  editDesk: '/edit-desk/:id',
  editOffice: '/edit-office/:id',
  createOffice: '/create-office',
  createDesk: '/create-desk',
  createDeskWithOffice: '/create-desk/:officeId',
  viewOffice: '/office/:officeId',
  notifications: '/notifications',
  help: '/help',
  profile: '/profile',
  myTeam: '/my-team',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  people: '/people',
  admin: '/admin',
  forgotPassword: '/forgot-password'
}

export default routes
